/* vi-bundle-move-checkout.js — fast, single-place mover (no thrash) */
(function () {
  var REAL_BTN_SEL = '.ab-dynamic-bundle-checkout-button';
  var TARGETS = [
    // Shakes gold placeholder (if you still use it)
    { slug: 'q6wlZzesOz', id: 'vi-checkout-placeholder' },
    // Mix-ins gold placeholder
    { slug: 'Da4hbrE7XV', id: 'vi-checkout-placeholder' }
  ];

  function slug() {
    var m = location.pathname.match(/\/apps\/bundles\/bb\/([^\/?#]+)/i);
    return m ? m[1] : '';
  }

  function getTargetId() {
    var s = slug();
    for (var i = 0; i < TARGETS.length; i++) {
      if (TARGETS[i].slug === s) return TARGETS[i].id;
    }
    return 'vi-checkout-placeholder';
  }

  var ROOT   = document.querySelector('.ab-bundle-section') || document.body;
  var TID    = getTargetId();
  var placed = false;
  var frozen = false; // pause mover when user clicks gold

  function qs(sel, root)  { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function findLatestButton() {
    // Appstle can render multiple; the last one is typically the live instance
    var btns = qsa(REAL_BTN_SEL, document);
    return btns.length ? btns[btns.length - 1] : null;
  }

  function moveOnce() {
    if (placed || frozen) return false;

    var target = document.getElementById(TID);
    var btn    = findLatestButton();
    if (!target || !btn) return false;

    // already placed?
    if (btn.parentElement === target) {
      placed = true;
      return true;
    }

    try {
      // Do NOT clear target; just append
      target.appendChild(btn);
      // Remove any inline display from previous mounts; let CSS handle layout
      try { btn.style.display = ''; } catch(_) {}
      placed = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  // Disconnect everything once placed
  function placeFastThenStop() {
    if (moveOnce()) {
      disconnect();
    }
  }

  // Mutation observer (starts enabled, but we disconnect immediately after the first success)
  var mo;
  function observe() {
    if (mo) return;
    mo = new MutationObserver(function () {
      if (!placed && !frozen) placeFastThenStop();
    });
    mo.observe(ROOT, { childList: true, subtree: true });
  }
  function disconnect() {
    if (mo) { try { mo.disconnect(); } catch(_) {} mo = null; }
  }

  // Pause mover during the actual click so we never relocate mid-handler
  function freezeOnClick() {
    document.addEventListener('click', function (e) {
      var gold = e.target.closest(REAL_BTN_SEL);
      if (!gold) return;
      frozen = true;
      // allow Appstle to finish; unfreeze after user leaves page or after a short grace if needed
      setTimeout(function(){ frozen = true; }, 0);
    }, true);
  }

  // INIT
  function init() {
    freezeOnClick();

    // quick attempts before observing
    for (var i = 0; i < 5 && !placed; i++) placeFastThenStop();

    if (!placed) observe();

    // also try on DOMContentLoaded in case bundle mounts after head scripts
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeFastThenStop, { once: true });
    } else {
      placeFastThenStop();
    }

    // as a last, very short retry window (no long polling)
    var tries = 10, iv = setInterval(function(){
      if (placed || frozen) { clearInterval(iv); return; }
      placeFastThenStop();
      if (--tries <= 0) clearInterval(iv);
    }, 120);
  }

  init();
})();